import React from "react";

const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0625 8.4375V3.75C10.0625 3.60082 10.0032 3.45774 9.89775 3.35225C9.79226 3.24676 9.64918 3.1875 9.5 3.1875C9.35082 3.1875 9.20774 3.24676 9.10225 3.35225C8.99676 3.45774 8.9375 3.60082 8.9375 3.75V8.4375H4.25C4.10082 8.4375 3.95774 8.49676 3.85225 8.60225C3.74676 8.70774 3.6875 8.85082 3.6875 9C3.6875 9.14918 3.74676 9.29226 3.85225 9.39775C3.95774 9.50324 4.10082 9.5625 4.25 9.5625H8.9375V14.25C8.93944 14.3986 8.99933 14.5405 9.1044 14.6456C9.20947 14.7507 9.35142 14.8106 9.5 14.8125C9.64918 14.8125 9.79226 14.7532 9.89775 14.6477C10.0032 14.5423 10.0625 14.3992 10.0625 14.25V9.5625H14.75C14.8992 9.5625 15.0423 9.50324 15.1477 9.39775C15.2532 9.29226 15.3125 9.14918 15.3125 9C15.3106 8.85142 15.2507 8.70947 15.1456 8.6044C15.0405 8.49933 14.8986 8.43944 14.75 8.4375H10.0625Z"
      fill="#232D3B"
    />
  </svg>
);

export default PlusIcon;
